import { useState, useCallback } from "react";

export function useGeolocation() {
  const [location, setLocation] = useState(null); // { lat, lng }
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const request = useCallback(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser.");
      return;
    }
    setLoading(true);
    setError(null);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        setLocation({ lat: coords.latitude, lng: coords.longitude });
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
        // Fall back to Plymouth city centre
        setLocation({ lat: 50.3714, lng: -4.1425 });
      },
      { enableHighAccuracy: true, timeout: 8000 }
    );
  }, []);

  return { location, error, loading, request };
}
